import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { BrandSocialMediaResponse } from './brand-social-media.response';

@jsonObject
export class BrandDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly homeUrl?: Nillable<string>;

  @jsonMember(MultimediaResponse)
  public readonly logo!: MultimediaResponse;

  @jsonMember(MultimediaResponse)
  public readonly illustration!: MultimediaResponse;

  @jsonArrayMember(BrandSocialMediaResponse, { name: 'socialNetworks' })
  public readonly socialMedia!: BrandSocialMediaResponse[];
}
